
import React from 'react';
import { getImg } from '@/pages/home/_config/getImgs';

interface IconType {
  type: string;
  className?: string;
  style?: React.CSSProperties;
  color?: string
}

const getLocaleDataSource = (type: string) => {
  let iconSrc = '';
  try {
    iconSrc = getImg(`${type}_`)
  } catch (err) {
    iconSrc = ''
  }
  return iconSrc;
}

export default function DataSourceIcon(props: IconType) {

  const { type, className, style, color } = props;

  return (
    <img
      src={getLocaleDataSource(type)}
      className={className}
      style={style}
    />
  )
}
